export default () => ({
  schedules: [],
  entity: 'schedule',
  entities: 'schedules',
  errors: {}
})



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/afters/resources/data.js